import React from "react";
import DesktopHeader from "./DesktopHeader";

const Header = () => {
  return (
    <>
      <DesktopHeader />
    </>
  );
};

export default Header;
